/** Fired when user clicks app “home” while already on the resolved home route (e.g. /kpis). */
export const APP_HOME_SAME_ROUTE_EVENT = 'nidata:app-home-same-route';

/** Fired when user clicks a shell mega-menu /report link while already on that destination. */
export const REPORT_SAME_ROUTE_EVENT = 'nidata:report-same-route';

export function scrollShellContentToTop(): void {
  const root = document.scrollingElement ?? document.documentElement;
  root.scrollTo({ top: 0, behavior: 'smooth' });
  window.scrollTo({ top: 0, behavior: 'smooth' });
  const main = document.querySelector('main.flex-1');
  if (main instanceof HTMLElement && main.scrollHeight > main.clientHeight) {
    main.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
